<template>
    <div class="product-video">
        <div class="product-video__upper">
            <div class="product-video__upper__embed">
                <base-video
                    :data="activeVideo.url"
                    :type="activeVideo.type"
                    :key="activeVideo.url"
                ></base-video>
            </div>
            <div v-if="activeVideo.caption" class="product-video__upper__caption">
                <p>{{ activeVideo.caption }}</p>
            </div>
        </div>

        <div class="product-video__lower" v-if="otherVideos.length">
            <h6 class="more uppercase">More Videos</h6>

            <ul class="product-video__thumbnails">
                <li 
                    class="product-video__thumbnail" 
                    v-for="video in otherVideos" :key="video.id"
                >
                    <div 
                        class="placeholder"
                        :style="`background-image: url(${video.poster});`"
                        @click="switchActiveVideo(video.id)"
                    >
                        <button
                            class="BaseVideo__icon">
                            <BaseIcon
                                icon="play-icon"
                                color="white"
                            />
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        videos: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            activeVideo: {},
            otherVideos: [],
        }
    },
    computed: {
        backgroundPoster() {
            if (this.type === 'youtube') {
                return `background-image: url("https://i.ytimg.com/vi/${this.url}/hqdefault.jpg")`
            } else {
                return `background-image: url("https://i.vimeocdn.com/video/${this.url}.jpg")`
            }
        }
    },
    methods: {
        setPosters() {
            this.videos.map((video) => {
                if(video.type === "youtube") {
                    video.poster = `https://i.ytimg.com/vi/${video.url}/hqdefault.jpg`;
                } else {
                    video.poster = `https://i.vimeocdn.com/video/${video.url}.jpg`;
                }
            });
        },
        initVideos() {
            this.videos.map((video, index) => {
                if(index === 0) {
                    this.activeVideo = video;
                } else {
                    this.otherVideos.push(video);
                }
            });
        },
        switchActiveVideo(id) {
            this.otherVideos = [];
            this.videos.map((video) => {
                if(video.id === id) {
                    this.activeVideo = video;
                } else {
                    this.otherVideos.push(video);
                }
            });
        }
    },
    mounted() {
        this.setPosters();
        this.initVideos();
    }
}
</script>

<style lang="scss" scoped>
	.product-video__upper {
		padding-bottom: getSpacing('medium');
	}

	.product-video__upper__embed {
        .video {
            position: relative;
            padding-bottom: 56.25%;
            height: 0;
        }

        .video__iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    .product-video__upper__caption {
        margin-top: getSpacing('medium');
    }
    
    .product-video__lower {
        border-top: 1px solid getColor('sand');
        padding-top: getSpacing('base');

        .more {
            font-size: 15px;
            margin-bottom: getSpacing('base');
        }
    }

    .product-video__thumbnails {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        grid-template-rows: auto;
        grid-gap: 16px;
        row-gap: 16px;
    }

    .product-video__thumbnail {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
        overflow: hidden;
        background: getColor('blue');
        
        .placeholder {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .BaseVideo__icon {
            width: 36px;
            height: 36px;
            position: relative;

            .BaseIcon {
                position: relative;
                width: 18px;
                height: 18px;
                left: 2px;
            }
        }
    }
</style>